/* eslint-disable camelcase */
import { SerializedHardware, SerializedHardwareItem } from '@enmon/commons/lib/tools';
import type { InstallMeterStore } from 'routes/installation/useStore';
import { SetState } from 'zustand';

export interface HardwareFormItem extends Pick<SerializedHardwareItem, 'id' | 'serial_number'> {
  hardwareName: SerializedHardware['name'];
}

export interface HardwaresStepForm {
  hardwares: HardwareFormItem[];
}

const INITIAL_STATE: HardwaresStepForm = {
  hardwares: [],
};

export interface HardwaresStepSlice extends HardwaresStepForm {
  setHardwares: (updater: (prevHardwares: readonly HardwareFormItem[]) => HardwareFormItem[]) => void;
}

export const createHardwaresStepSlice = (set: SetState<InstallMeterStore>): HardwaresStepSlice => ({
  ...INITIAL_STATE,
  setHardwares: (updater: (prevHardwares: readonly HardwareFormItem[]) => HardwareFormItem[]): void =>
    set(prevState => ({
      ...prevState,
      hardwares: updater(prevState.hardwares),
    })),
});
